import initialState from './state.js';

const RESET_STATE = (state) => {
  const iState = initialState.get();
  // Preserve fetching state
  iState.fetching = state.fetching;
  Object.assign(state, iState);
};

const FETCHING = (state, value) => {
  state.fetching = !!value;
};

const MINTING = (state, value) => {
  state.minting = !!value;
};

const FETCH_SUCCESS = (state, value) => {
  state.success = !!value;
};

const FETCH_ERROR = (state, value) => {
  state.error = value;
};

const SET_VALUES = (state, values) => {
  state.values = values;
};

const SET_ACCESS = (state, value) => {
  state.access = value;
};

export default {
  FETCHING,
  MINTING,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SET_VALUES,
  SET_ACCESS,
  RESET_STATE,
};
